module.exports = __webpack_public_path__ + "static/img/banner_map_20241231.jpg";